import React from 'react';

export default function SupportFooter({ supportUrl, supportPhone }) {
    // Non-internal distributors get a phone number; everyone else keeps the
    // tech-support link. The controller only sends supportPhone for the former.
    return (
        <footer className="demo-edit-footer border-top pt-3 mt-3 text-center" data-testid="demo-edit-footer">
            <p className="mb-0">
                {supportPhone
                    ? <>{__('Need help? Contact us at')}{' '}<a href={`tel:+1${supportPhone}`}>{supportPhone}</a>.</>
                    : <>{__('Need help?')} <a href={supportUrl}>{__('Submit a support request')}</a> {__('for immediate assistance')}</>
                }
            </p>
        </footer>
    );
}
